var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscordGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2430_2394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.29 0C20.65 0 21.75 1.1 21.75 2.47V24L19.17 21.72L17.72 20.38L16.18 18.95L16.82 21.17H3.21C1.85 21.17 0.75 20.07 0.75 18.7V2.47C0.75 1.1 1.85 0 3.21 0H19.29ZM14.66 15.67C17.31 15.59 18.33 13.85 18.33 13.85C18.33 9.99 16.6 6.85 16.6 6.85C14.87 5.55 13.23 5.59 13.23 5.59L13.06 5.78C15.1 6.4 16.05 7.3 16.05 7.3C14.8 6.62 13.58 6.28 12.44 6.15C11.58 6.05 10.75 6.08 10.02 6.17L9.82 6.19C9.4 6.23 8.38 6.38 7.1 6.95C6.66 7.15 6.39 7.3 6.39 7.3C6.39 7.3 7.39 6.35 9.55 5.73L9.43 5.59C9.43 5.59 7.79 5.55 6.06 6.85C6.06 6.85 4.33 9.98 4.33 13.85C4.33 13.85 5.34 15.59 7.99 15.67C7.99 15.67 8.43 15.13 8.79 14.67C7.27 14.21 6.69 13.25 6.69 13.25L7.03 13.45L7.08 13.49L7.13 13.52H7.14L7.19 13.55C7.49 13.72 7.79 13.85 8.07 13.96C8.56 14.15 9.15 14.34 9.83 14.48C10.73 14.65 11.79 14.71 12.94 14.49C13.5 14.39 14.08 14.23 14.68 13.97C15.1 13.81 15.57 13.59 16.06 13.26C16.06 13.26 15.46 14.24 13.89 14.69C14.25 15.15 14.68 15.66 14.68 15.66L14.66 15.67ZM9.08 10.07C8.4 10.07 7.86 10.67 7.86 11.4C7.86 12.13 8.41 12.73 9.08 12.73C9.75 12.73 10.3 12.13 10.3 11.4C10.31 10.67 9.76 10.07 9.08 10.07ZM13.46 10.07C12.78 10.07 12.24 10.67 12.24 11.4C12.24 12.13 12.79 12.73 13.46 12.73C14.13 12.73 14.68 12.13 14.68 11.4C14.68 10.67 14.14 10.07 13.46 10.07Z",
    fill: "#188C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2430_2394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordGreen);
export default __webpack_public_path__ + "static/media/discord-green.b79a840769163f34a91a9312eea1f3ae.svg";
export { ForwardRef as ReactComponent };